import { render, staticRenderFns } from "./groupsTab.vue?vue&type=template&id=01f33620&scoped=true"
import script from "./groupsTab.vue?vue&type=script&lang=js"
export * from "./groupsTab.vue?vue&type=script&lang=js"
import style0 from "./groupsTab.vue?vue&type=style&index=0&id=01f33620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f33620",
  null
  
)

export default component.exports